<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FZ1e6E/tc-custom/9781439679319.jpg?1738411513063" alt="This image is the cover for the book Ghost Pirates of Boston"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghost Pirates of Boston
      </h1>
      <p class="bookDescription body article font2">
        <p>IT'S A CRUEL SUMM ER  Arrrr!    All Sam wants this summer is to watch baseball, play video games, and read his favorite supernatural series. Too bad his cousin, Alex, is visiting from San Francisco, and now Sam's stuck playing tour guide to a kid he hardly knows... a kid who'd choose sailing camp over stealing bases  any  day.    Then Sam and Alex find themselves swept up in an epic pirate adventure through the historic streets of Boston. With the help of a three-hundred-year-old ghost-pirate, they'll have to piece together the clues of a long-lost treasure map-- and  master a tricky sailor's knot--or risk becoming ghosts themselves! The cousins may not have much in common, but along the way they'll learn that some bonds, like some knots, are truly  unbreakable .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Hester
      </h2>
      
      <p class="authorDescription body article">BETH HESTER is originally from the haunted city of New Orleans, where she sometimes heard ghostly footsteps in the very old house where she grew up…and awoke one morning to find a mysterious footprint on her ceiling! These days, she lives in New England with her husband, two children, and one spooky dog, and (most of) the footprints stay on the floor. You can find her at  bethhester.com .</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Children’s Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63213e4f